import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { combineLatest, filter, Subscription, tap } from 'rxjs';

import { DateQueryDateTypeEnum } from '../../../../api/mentions/enum/date-query-date-type.enum';
import { SearchCriteriaSortFieldEnum } from '../../../../api/mentions/enum/search-criteria-sort-field.enum';

import { SearchStatesEnum } from '../../../../Monitor/Shared/enums/search-states.enum';
import { SearchRangeModel } from '../../../../Monitor/Core/models/search-range.model';
import { SearchStateErrorModel } from '../../../../Monitor/Core/models/search-state-error.model';
import { MonitorConfigService } from '../../../../Common/MonitorShared/services/monitor-config.service';
import { getMonitoringDateQueryInputTopicOptions } from '../../../../Monitor/Shared/models/monitoring-date-query-input-options';

import { ScrollPanelComponent } from '../../../../Common/Basic/components/ScrollPanel/scroll-panel.component';
import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { DateQueryModel } from '../../../../Common/Forms/models/date-query.model';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { Mention } from '../../../../Common/Mentions/models/mention';
import { RelativeTimePipe } from '../../../../Common/Misc/pipes/RelativeTime/relative-time.pipe';

import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { FilterTypeModel } from '../../../../Common/Filter/models/abstract-filter-type.model';
import { KeywordHighlightModel } from '../../../../Common/Misc/models/keyword-highlight.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { SocialSearchService } from '../../../Core/services/social-search.service';

import { ThemeService } from '../../services/theme.service';
import { SocialBulkActionsDialogComponent } from '../SocialBulkActionsDialog/social-bulk-actions-dialog.component';
import { SocialRoutingService } from '../../../Core/services/social-routing.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { SocialArchiveSearchService } from '../../services/social-archive-search.service';
import { MentionsService } from '../../../../Monitor/Core/services/mentions.service';
import { Theme } from '../../models/theme.model';
import { MentionSearchCriteriaModel } from '../../../../Monitor/Shared/models/mention-search-criteria.model';

import { ActionKeys } from '../../../../Common/Forms/enums/keys.enum';
import { Folder } from '../../../../Monitor/Shared/models/folder.model';
import { InvalidFiltersError } from '../../../../Monitor/Shared/errors/invalid-filters.error';
import { SearchError } from '../../../../Monitor/Core/errors/search.error';
import { SearchErrorsEnum } from '../../../../Monitor/Core/enums/search-errors.enum';
enum PostViewOptionsEnum {
    showMedia,
    hideMedia,
    showMentionIndex,
    hideMentionIndex
}

enum SearchErrorTypeEnum {
    none,
    unknown,
    filters,
    queryLength,
    apiLimit
}

@Component({
    selector: 'agpr-theme-post-feed',
    templateUrl: './theme-post-feed.component.html',
    styleUrls: ['./theme-post-feed.component.scss'],
    providers: [
        {
            provide: FilterService,
            useExisting: SocialSearchService
        },
        {
            provide: 'PaginatorServiceInterface',
            useExisting: SocialSearchService
        }
    ],
    standalone: false
})
export class ThemePostFeedComponent implements OnInit, OnDestroy {

    @Input() id: string = 'themePostFeed';

    @ViewChild('scrollPanel') scrollPanel: ScrollPanelComponent;
    @ViewChildren('mentionsList') mentionsList: QueryList<ElementRef>;

    @Input() doSearch: boolean = true;
    @Input() drillDownAgentSegment: boolean = false;
    @Input() currentThemeId: string;

    @Output() engagementSwitchChanged = new EventEmitter<boolean>();

    readonly MAX_API_POSTS: number = 10000;
    readonly messageSeverity = messageSeverityEnum;
    readonly agprComponentStyle = AgprComponentStyleEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly userPermissionsEnum = userPermissionsEnum;
    readonly errorTypes = SearchErrorTypeEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    public searchDateRange: DateQueryModel;
    showImageOption: DropdownOptionModel = new DropdownOptionModel('Social.postFeed.showMedia', PostViewOptionsEnum.showMedia);
    hideImageOption: DropdownOptionModel = new DropdownOptionModel('Social.postFeed.hideMedia', PostViewOptionsEnum.hideMedia);

    searchCriteria: MentionSearchCriteriaModel;

    mentionIndexOffset: number = 0;
    showPostIndex: boolean = true;
    showMentionIndexOption: DropdownOptionModel = new DropdownOptionModel(
        'Social.postFeed.showPostIndex',
        PostViewOptionsEnum.showMentionIndex
    );
    hideMentionIndexOption: DropdownOptionModel = new DropdownOptionModel(
        'Social.postFeed.hidePostIndex',
        PostViewOptionsEnum.hideMentionIndex
    );
    mentionViewOptions: DropdownOptionModel[] = [
        this.showImageOption,
        this.hideMentionIndexOption
    ];
    mentions: Mention[];
    selectedMentions: Mention[] = [];
    allSelected: boolean = false;
    subscriptions: Subscription[] = [];
    agentIds: number[];
    filterError: InvalidFiltersError;
    errorType: SearchErrorTypeEnum = SearchErrorTypeEnum.none;

    public highlightKeywords: KeywordHighlightModel[] = [];
    enableEngagementInsights: boolean = true;

    public showPublishedDate: boolean = true;
    public dateOptions: DropdownOptionModel[] = getMonitoringDateQueryInputTopicOptions();
    public searchRange: SearchRangeModel = null;

    selectedMentionViewOption: DropdownOptionModel;
    public showMedia: boolean = false;

    relativeTimePipe: RelativeTimePipe;
    isLoadingMentions: boolean = false;

    mentionCount: number = 0;
    maxMentionCountLimit = 10000;
    filterApplied: boolean = false;

    activeFilters: FilterTypeModel[];
    isArchiveSearch: boolean = false;
    hasMonitoring: boolean = false;

    currentTheme: Theme = null;

    selectedFolder: Folder;

    constructor(
        private localizationService: LocalizationService,
        private socialSearchService: SocialSearchService,
        private mentionsService: MentionsService,
        public monitorConfigService: MonitorConfigService,
        private themeService: ThemeService,
        private coreDialogService: CoreDialogService,
        private socialRoutingService: SocialRoutingService,
        private currentUserStateService: CurrentUserStateService,
        private socialArchiveSearchService: SocialArchiveSearchService,
        private el: ElementRef
    ) {
        this.relativeTimePipe = new RelativeTimePipe(this.localizationService);
    }

    ngOnInit(): void {
        this.createSubscriptions();
    }

    /**
     * Creates the subscriptions this component relies on
    */
    public createSubscriptions(): void {
        this.subscriptions.push(
            this.socialSearchService.getItemCount().subscribe(
                mentionCount => {
                    if (!mentionCount) {
                        this.mentionCount = 0;
                        return;
                    }
                    this.mentionCount = mentionCount;
                }
            ),
            this.mentionsService.getMentions().subscribe(mentions => {
                if (this.hasMonitoring) {
                    this.processMentions(mentions);
                }
            }),
            this.socialSearchService.getMentions().subscribe(mentions => {
                if (!this.hasMonitoring) {
                    this.processMentions(mentions);
                }
            }),
            this.socialSearchService.getDateQuery().subscribe(dateQuery => this.searchDateRange = dateQuery),
            this.socialSearchService.getSearchState().subscribe(
                searchState => {
                    this.filterError = null;
                    switch (searchState.type) {
                        case SearchStatesEnum.loading:
                            requestAnimationFrame(() => {
                                this.isLoadingMentions = true;
                            });
                            break;
                        case SearchStatesEnum.error:
                            const errorState = searchState as SearchStateErrorModel;
                            requestAnimationFrame(() => {
                                this.isLoadingMentions = false;
                            });
                            if (errorState.error instanceof InvalidFiltersError) {
                                this.errorType = SearchErrorTypeEnum.filters;
                                this.filterError = errorState.error;
                            } else if (errorState.error instanceof SearchError) {
                                switch (errorState.error.type) {
                                    case SearchErrorsEnum.queryTooLong:
                                        this.errorType = SearchErrorTypeEnum.queryLength;
                                        break;
                                    case SearchErrorsEnum.outsideApiLimit:
                                        this.errorType = SearchErrorTypeEnum.apiLimit;
                                        break;
                                    case SearchErrorsEnum.unknown:
                                    default:
                                        this.errorType = SearchErrorTypeEnum.unknown;
                                        break;
                                }
                            } else {
                                this.errorType = SearchErrorTypeEnum.unknown;
                            }
                            break;
                        case SearchStatesEnum.success:
                            requestAnimationFrame(() => {
                                this.isLoadingMentions = false;
                            });
                            this.scrollPanel?.scrollTo(0, 0, false);
                            break;
                        default:
                            requestAnimationFrame(() => {
                                this.isLoadingMentions = false;
                            });
                    }
                }
            ),
            this.socialSearchService.agentIds$.pipe(filter(x => !!x)).subscribe(agentIds => {
                this.agentIds = agentIds;
            }),
            this.monitorConfigService.getSearchRange().subscribe(searchRange => this.searchRange = searchRange),
            this.socialSearchService.getSearchCriteria().pipe(filter(x => !!x)).subscribe(searchCriteria => {
                this.searchCriteria = searchCriteria;
                this.showPublishedDate = searchCriteria.sortField !== SearchCriteriaSortFieldEnum.indexed_date;
            }),
            this.socialSearchService.activeFilters$.subscribe(activeFilters => {
                if (activeFilters) {
                    this.activeFilters = activeFilters;
                    this.checkIfFilterApplied();
                }
            }),
            this.socialSearchService.getHighlightKeywords().subscribe(
                highlightKeywords => {
                    this.highlightKeywords = highlightKeywords;
                }
            ),
            combineLatest([
                this.themeService.currentResource$.pipe(filter(x => !!x)),
                this.socialRoutingService.isArchiveSearch$.pipe(
                    tap(isArchiveSearch => {
                        this.isArchiveSearch = isArchiveSearch;
                        if (this.isArchiveSearch) {
                            this.socialSearchService.clearAgents();
                            this.socialSearchService.search(true);
                        }
                    })
                )
            ]).subscribe(
                ([theme, isArchiveSearch]) => {
                    this.currentTheme = theme;
                    if (!isArchiveSearch && this.doSearch) {
                        this.socialSearchService.clearSocialSearchRequest();
                        this.socialSearchService.search(true);
                    }
                }
            ),
            this.socialSearchService.getPageCriteria().pipe(filter(x => !!x))
                .subscribe(criteria => this.mentionIndexOffset = (criteria.page - 1) * criteria.pageSize),
            this.currentUserStateService.getPermissions().subscribe(permissions => {
                if (permissions) {
                    this.hasMonitoring = permissions.includes(userPermissionsEnum.advancedMonitoring);
                }
            }),
            this.socialArchiveSearchService.enableEngagementInsights$.subscribe(x => this.enableEngagementInsights = x)
        );
    }

    checkIfFilterApplied(){
        let filterOn = false;
        for (const filterModel of this.activeFilters){
            const filterValue = filterModel.getValue();
            if (filterValue instanceof Array && filterValue.length !== 0){
                filterOn = true;
                break;
            }
            if (filterValue['expertQuery']){
                if (filterValue['expertQuery']['filter'] !== ''){
                    filterOn = true;
                    break;
                }
            }
            if (filterValue['keywordGroup']){
                if (filterValue['keywordGroup']['and'].length !== 0 || filterValue['keywordGroup']['not'].length !== 0 ||
                    filterValue['keywordGroup']['or'].length !== 0){
                    filterOn = true;
                    break;
                }
            }
            if ((filterValue['min'] && !isNaN(filterValue['min'])) || (filterValue['max'] && !isNaN(filterValue['max']))){
                filterOn = true;
                break;
            }

        }
        this.filterApplied = filterOn;
    }

    /**
     * updates the date range and re-runs the search
     *
     * @param dateRange
     *
     * @returns void
     */
    dateRangeChanged(dateRange: DateQueryModel): void {
        this.socialSearchService.setDateQuery(dateRange);
        const sortField = dateRange.dateType === DateQueryDateTypeEnum.HARVESTED ?
            SearchCriteriaSortFieldEnum.indexed_date : SearchCriteriaSortFieldEnum.published;
        this.socialSearchService.setSortField(sortField);
        this.socialSearchService.setPageNumber(1);
        if (this.agentIds?.length || this.isArchiveSearch) {
            this.socialSearchService.search(true);
        } else {
            this.socialSearchService.clearSearch();
            this.socialSearchService.setMentions([]);
        }

        if (this.isArchiveSearch) {
            this.socialArchiveSearchService.setSearchDateRange(this.searchDateRange);
        }
    }

    selectMentionViewOption(): void {
        const opt = this.selectedMentionViewOption;
        switch (opt.value) {
            case PostViewOptionsEnum.showMedia:
                this.showMedia = true;
                break;
            case PostViewOptionsEnum.hideMedia:
                this.showMedia = false;
                break;
            case PostViewOptionsEnum.showMentionIndex:
                this.showPostIndex = true;
                break;
            case PostViewOptionsEnum.hideMentionIndex:
                this.showPostIndex = false;
                break;
        }
        this.updateMentionViewOptions();
    }

    updateMentionViewOptions(): void {
        this.mentionViewOptions = [
            this.showMedia ? this.hideImageOption : this.showImageOption,
            this.showPostIndex ? this.hideMentionIndexOption : this.showMentionIndexOption
        ];
        this.selectedMentionViewOption = null;
    }

    /**
     * Selects or deselects all mentions on the page
     */
    public toggleSelectAll(): void {
        if (this.mentions.length === this.selectedMentions.length) {
            this.selectedMentions = [];
            this.allSelected = false;
        } else {
            this.selectedMentions = this.mentions.slice();
        }
    }

    public selectAllResults(): void {
        this.allSelected = true;
    }

    updatePostSelection(mentions: Mention[]): void {
        this.selectedMentions = mentions;
    }

    openBulkActionsDialog() {
        const socialSearchCriteria = MentionSearchCriteriaModel.createFiltered(
            this.searchCriteria,
            this.socialSearchService.generateSearchFromFilters(false),
            false
        );

        const bulkActionsDialogConfig: DialogIoModel = {
            inputs: {
                allSelected: this.allSelected,
                total: this.mentionCount,
                selectedResults: this.selectedMentions,
                existingDateQuery: this.searchDateRange,
                currentTheme: this.currentTheme,
                drillDownAgentSegment: this.drillDownAgentSegment,
                currentThemeId: this.currentThemeId,
                socialSearchCriteria
            },
            outputs: {
            }
        };
        this.coreDialogService.open(SocialBulkActionsDialogComponent, bulkActionsDialogConfig);
    }

    switchClick(): void {
        if (this.doSearch) {
            this.socialArchiveSearchService.setenableEngagementInsights(this.enableEngagementInsights);
            this.socialSearchService.search(true);
        } else {
            this.engagementSwitchChanged.emit(this.enableEngagementInsights);
        }
    }

    processMentions(mentions: Mention[]): void {
        if (!mentions) {
            this.mentions = [];
            return;
        }

        let isRefresh = true;
        if (mentions && this.mentions && mentions.length === this.mentions.length) {
            for (let i = 0, l = mentions.length; i < l; i++) {
                const oldMention = this.mentions[i];
                const newMention = mentions[i];
                if (oldMention.id !== newMention.id || oldMention.mentionId !== newMention.mentionId) {
                    isRefresh = false;
                    break;
                }
            }
        } else {
            isRefresh = false;
        }

        this.mentions = mentions.slice();

        if (!isRefresh) {
            this.selectedMentions = [];
        } else {
            this.selectedMentions = this.mentions.filter(mention => {
                return !!this.selectedMentions.find(selectedMention => {
                    return (selectedMention.id && selectedMention.id === mention.id) || selectedMention.mentionId === mention.mentionId;
                });
            });
        }
    }

    onKeydown(event: KeyboardEvent) {
        if (!this.mentions || this.mentions.length === null) {
            return;
        }
        let focusedItem = null;
        let focusedItemIndex = null;
        if (event.target instanceof HTMLElement) {
            focusedItem = (event.target as HTMLElement).matches('li.agpr-themePostFeed-mention') ?
                event.target : event.target.closest('li.agpr-themePostFeed-mention');
            if (!focusedItem) {
                return;
            }
            focusedItemIndex = focusedItem.getAttribute('aria-posinset');
        }
        const focusableElement = this.el.nativeElement.querySelectorAll('button, [href], input, [tabindex="0"]');
        switch (event.key) {
            case ActionKeys.PAGEUP:
                // Move up focus
                event.preventDefault();
                if (focusedItemIndex > 1) {
                    // Need to increment by 2 because focusedItemIndex is 1-indexed
                    this.mentionsList.toArray()[focusedItemIndex - 2].nativeElement.focus();
                }
                break;
            case ActionKeys.PAGEDOWN:
                // Move down focus
                event.preventDefault();
                if (this.mentions.length >= focusedItemIndex) {
                    // Do not need to increment focusedItemIndex because it is 1-indexed
                    this.mentionsList.toArray()[focusedItemIndex].nativeElement.focus();
                }
                break;
            case ActionKeys.HOME:
                // Move focus to the first focusable element after the feed
                if (event.ctrlKey && this.mentions.length > 0) {
                    event.preventDefault();
                    focusableElement[0].focus();
                }
                break;
            case ActionKeys.END:
                // Move focus to the first focusable element before the feed
                if (event.ctrlKey) {
                    event.preventDefault();
                    focusableElement[focusableElement.length - 1].focus();
                }
                break;
        }
    }

    folderChanged(folder: Folder) {
        this.selectedFolder = folder;
    }

    /**
    * Removes current subscriptions on destroy
    */
    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
        this.socialSearchService.registerPagingValidator(null);
    }
}
